import { Component, Input, AfterViewInit } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import $ from 'jquery';

@Component({
  selector: 'is-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss']
})
export class SearchFiltersComponent implements AfterViewInit {

  // properties
  @Input() public backgroundColor: string = 'transparent'; // background color of entire component
  @Input() public height: number; // height in px
  @Input() public width: number; // width in px
  @Input() public placeholder: string = 'add a [placeholder] in input ...'; // a placeholder for input
  @Input() public showDropDown: boolean = true; // show or hide the arrow to open panel
  @Input() public color: string = 'black'; // color of border, of arrow, of input and its placeholder
  @Input() public cancelText: string = 'COMMON.reset'; // the text displayed in cancel button
  @Input() public saveText: string = 'COMMON.FILTERS.apply_filters'; // the text displayed in save button
  @Input() public showConfigure: boolean = true; // choose if show configur button
  @Input() public configureText: string = 'COMMON.configure'; // the text displayed in configure button
  @Input() public radius: number = 4; // border radius in px
  @Input() public fontSize: number = 14; // size of font about input and placeholder in px
  @Input() public searchedValue: string = ''; // the value binded to input box

  public showpanel: boolean = false; // internal prop useful to show or hide panel

  @Output() public search = new EventEmitter<string>(); // event when enter has been pressed
  @Output() public cancel = new EventEmitter<any>(); // event when cancel has been clicked
  @Output() public save = new EventEmitter<any>(); // event when save has been clicked
  @Output() public configure = new EventEmitter<any>(); // event when configure has been clicked
  @Output() public xClicked = new EventEmitter<any>(); // event when X button has been clicked to cancel the searched value
  @Output() public clicked = new EventEmitter<any>();

  public placeholderCopy;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  ngAfterViewInit() {
    this.stylingPlaceholder();
    this.placeholderCopy = this.placeholder;
  }

  /**
   * emit the event with
   * actual searched value in
   * input box, called when user press enter
   * after a research
   */
  public emitSearch() {
    this.search.emit(this.searchedValue);
  }

  /**
   * clear input method called
   * when user clicks on the X icon
   */
  public clearInput(): void {
    this.searchedValue = '';
    this.xClicked.emit();
  }

  public clearPlaceholder(): void {
    this.placeholderCopy = this.placeholder;
    this.placeholder = null;
  }

  /**
   * emit the event about "configure button"
   */
  public configureClicked() {
    this.configure.emit();
  }

  /**
   * emit the event about "cancel button"
   * called when "cancel" has been clicked
   */
  public cancelClicked() {
    this.cancel.emit();
    this.showpanel = false;
  }

  /**
   * emit the event about "save button"
   * called when "save" has been clicked
   */
  public saveClicked() {
    this.save.emit();
    this.showpanel = false;
  }

  /**
   * toggle the panel status
   * to opened or closed
   */
  public togglePanel() {
    this.showpanel = !this.showpanel;
  }

  /**
   * method to add a line of style in body, useful to
   * set the color of placeholder
   * ps: js can't take the placeholder element directly with its selector
   * because it is a pseudo tag
   */
  public stylingPlaceholder() {
    $('body').append(`<style>#search-filter-text::placeholder{color:${this.color}}</style>`);
  }
}
